import { useGetUserQuery } from "../query/usersQuery";
import { UserRole } from "@KassaroAB/shared/types/enums/UserRole";

export const useIsAdmin = (): boolean => {
  const { data: user } = useGetUserQuery();
  return user?.role === UserRole.ADMIN;
};

export const useIsReseller = (): boolean => {
  const { data: user } = useGetUserQuery();
  return user?.role === UserRole.RESELLER_ADMIN;
};